import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { TargetSectorListComponent } from './target-sector-list/target-sector-list.component'

export const targetSectorRoutes: Route[] = [
  {
    path: 'target-sectors',
    component: TargetSectorListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permissions: ['browseTaxonomies', 'browsePolicyInitiativeTaxonomies']
    }
  },
  {
    path: 'target-sectors/:id/edit',
    redirectTo: 'target-sectors/:id',
    pathMatch: 'full'
  },
  {
    path: 'target-sectors/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'TargetSector',
        nameSingular: 'Target Sector',
        namePlural: 'Target Sectors',
        path: 'target-sectors',
        slug: 'taxonomies/target-sectors',
        title: 'Target Sectors'
      }),
      permissions: ['readTaxonomies', 'readPolicyInitiativeTaxonomies']
    }
  }
]
